export const createData = (data) => {
  let newData = data.map((item) => {
    return {
      value: item,
      label: item,
    };
  });
  return newData;
};
